module.exports = __webpack_public_path__ + "static/media/instapage5.7920e72b.png";